import { AuthTokens } from "@/model/AuthTokens"
import { getDefaultStore, useAtom } from "jotai"
import { atomWithStorage } from "jotai/utils"

// This persists using localStorage internally
const authTokensAtom = atomWithStorage<AuthTokens | null>(
  "tokens",
  null,
  undefined,
  {
    getOnInit: true,
  }
)
export const authTokens = () => getDefaultStore().get(authTokensAtom)
export const setAuthTokens = (tokens: AuthTokens | null) =>
  getDefaultStore().set(authTokensAtom, tokens)
export const useAuthTokensAtom = () => useAtom(authTokensAtom)
